import { ErrorResponse, GlobalResponseObject, GlobalVariableValues, MessageParameters } from '@gtpl/shared-models/common-models';
import { EmployeeNameRequest, EmployeeRequest, EmployeesDeptWiseCountDto, EmployeesDeptWiseResponseModel, EmployeeUpdateReq } from '@gtpl/shared-models/gtpl';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getConnection, getManager, IsNull, Not, Raw, Repository } from 'typeorm';
import { EmployeeDetailsAdapter } from './dto/employee-details.adapter';
import { EmployeeDetailsDTO } from './dto/employee-details.dto';
import { EmployeeDetails } from './employee-details.entity';
import { EmployeeService } from '@gtpl/shared-services/attendance';
import { EmployeeRoleRequest } from './dto/employee-role.request';
import { HrmsResponseModel, HrmsAllResponseModel, CommonResponse, EmployeeResponseModel, AllEmployeesResponseModel, EmployeeDepartmentRequest, ContractorIdReq } from '@gtpl/shared-models/masters';
import { EmployeeDesignationRequest } from './dto/employee-designation';
import { EmployeeDeptRequest } from './dto/employee-dept.request';
import { Departments } from '../departments/departments.entity';
import { EmployeeCodeRequest } from './dto/employee-code.request';
import { EmployeeRepo } from './dto/employee.repository';
import { DeptRequest } from './dto/dept-request';
import appSettings from 'apps/services/config';
import { EmployeeByUnitRequest } from './dto/employee-by-unit-request';
import { AttendanceService, DesignationService, PayrollProcessServices } from '@gtpl/shared-services/hrms';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { EmployeeCodesRequest, PayrollRequestEmp } from '@gtpl/shared-models/hrms';
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import whatsApp from 'apps/services/whatsapp';
import { WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { DepartmentService } from '@gtpl/shared-services/masters';

@Injectable()
export class EmployeeDetailsService {

  constructor(
    private employeeDetailsRepository: EmployeeRepo,
    @InjectRepository(Departments)
    private deptRepository: Repository<Departments>,
    private employeeDetailsAdapter: EmployeeDetailsAdapter,
    private userService: EmployeeService,
    private attendanceService: AttendanceService,
    private payrollService: PayrollProcessServices,
    private wpService: WhatsAppNotificationService,
    private departmentService: DepartmentService,
    private designationService: DesignationService,
  ) { }

  async getEmployeeWithoutRelations(employeeCode: string): Promise<EmployeeDetails> {
    const EmployeeResponse = await this.employeeDetailsRepository.findOne({
      where: { employeeCode: Raw(alias => `employee_code = '${employeeCode}'`) },
    });
    if (EmployeeResponse) {
      return EmployeeResponse;
    }
    else {
      return null;
    }
  }

  async getEmployeeMobile(mobileNumber: string): Promise<EmployeeDetails> {
    const EmployeeResponse = await this.employeeDetailsRepository.findOne({
      where: { mobileNumber: Raw(alias => `mobile_no = '${mobileNumber}'`) },
    });
    if (EmployeeResponse) {
      return EmployeeResponse;
    }
    else {
      return null;
    }
  }

  async getEmployeeAadhaar(aadhaarNumber: string): Promise<EmployeeDetails> {
    const EmployeeResponse = await this.employeeDetailsRepository.findOne({
      where: { aadhaarNumber: Raw(alias => `aadhaar_number = '${aadhaarNumber}'`) },
    });
    if (EmployeeResponse) {
      return EmployeeResponse;
    }
    else {
      return null;
    }
  }

  async createEmployee(employeeDetailsDTO: EmployeeDetailsDTO, isUpdate: boolean): Promise<HrmsResponseModel> {
    const transManager = new GenericTransactionManager();
    try {
      if (!isUpdate) {
        const EmployeeEntity = await this.getEmployeeWithoutRelations(employeeDetailsDTO.employeeCode);
        if (EmployeeEntity) {
          return new HrmsResponseModel(false, 11104, 'Employee already exists');
        }
        const EmployeeEntity1 = await this.getEmployeeMobile(employeeDetailsDTO.mobileNumber);
        if (EmployeeEntity1) {
          return new HrmsResponseModel(false, 11164, 'Mobile Number already exists');
        }
        const EmployeeEntity2 = await this.getEmployeeAadhaar(employeeDetailsDTO.aadhaarNumber);
        if (EmployeeEntity2) {
          return new HrmsResponseModel(false, 11544, 'Aaadhaar Number already exists');
        }

        // if (employeeDetailsDTO.employeeType === 'Salaried Form') {
        //   const empDetails = await this.employeeDetailsRepository.getExcutiveEmployeeCode();
        //   if (empDetails) {
        //     const lastEmpCode = empDetails.employeeCode;
        //     employeeDetailsDTO.employeeCode = "SA" + (Number(lastEmpCode.toString().slice(2)) + 1);
        //   } else {
        //     employeeDetailsDTO.employeeCode = "SA25";
        //   }
        // } else {
        //   const empDetails = await this.employeeDetailsRepository.getWorkerEmployeeCode();
        //   if (empDetails) {
        //     const lastEmpCode = empDetails.employeeCode;
        //     employeeDetailsDTO.employeeCode = "SAW" + (Number(lastEmpCode.toString().slice(3)) + 1);
        //   } else {
        //     employeeDetailsDTO.employeeCode = "SAW1";
        //   }
        // }
      }
      const req = new EmployeeCodesRequest([employeeDetailsDTO.employeeCode]);
      await transManager.startTransaction();
      const convertedEmployeeEntity: EmployeeDetails = this.employeeDetailsAdapter.convertDtoToEntity(employeeDetailsDTO, isUpdate);
      const savedEmployeeEntity = await this.employeeDetailsRepository.save(convertedEmployeeEntity);
      if (savedEmployeeEntity) {
        const createLogs = await this.attendanceService.createEmpAttnLogForToday(req);
        if (createLogs) {
          const savedEmployeeDto: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(savedEmployeeEntity);


          const saveFlag = new Set<boolean>()
          if (isUpdate == false) {
            const userService = await this.userService.createEmployee(savedEmployeeDto);
            if(userService){
              saveFlag.add(true)
            }else{
              saveFlag.add(false)
              return;
            }
          }
          if (isUpdate == true) {
            const userService = await this.userService.updateEmployee(savedEmployeeDto);
            if(userService){
              saveFlag.add(true)
            }else{
              saveFlag.add(false)
              return;
            }
          }

          if (savedEmployeeDto) {
            console.log(savedEmployeeDto.employeeId, "'savedEmployeeDto.employeeId'")
            await transManager.completeTransaction();
            const payrollReq = {
              employeeId: savedEmployeeDto.employeeId,
              employeeCode: savedEmployeeDto.employeeCode,
              employeeType: savedEmployeeDto.employeeType,
              employeeCategory: savedEmployeeDto.employeeCategory,
              employeeName: `${savedEmployeeDto.employeeName} ${savedEmployeeDto.employeeLastName}`,
              designation: savedEmployeeDto.designation,
              department: savedEmployeeDto.departmentId,
              unitId: savedEmployeeDto.unitId
            };
            const payroll = await this.payrollService.saveEmployeePayrollComponent(payrollReq)
            const currDate = new Date();
            const deptId = savedEmployeeDto.departmentId;
            console.log(deptId,"deptId")
            const designationId = savedEmployeeDto.departmentId
            console.log(designationId,"designationId")
            const deptInfo = await this.departmentService.getAllDepartments();

            const deptNameMap = new Map<number, string>();
            deptInfo.data.forEach(dept => deptNameMap.set(dept.deptId, dept.deptName));
            const deptName = deptNameMap.get(Number(deptId)) || 'Unknown Department';
            console.log(deptName,"deptName")

            const designationInfo = await this.designationService.getAllDesignation();
            const designationNameMap = new Map<number, string>();
              designationInfo.data.forEach(designation =>
                designationNameMap.set(designation.designationId, designation.designation)
              );
            const designationName = designationNameMap.get(Number(designationId)) || 'Unknown designation';
            console.log(designationName,"designationName")
            const date = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + currDate.getDate();
            const time = currDate.getHours() + ':' + currDate.getMinutes() + ':' + currDate.getSeconds();
            const parameters = [
              { "type": "text", "text": date + " " + time },
              { "type": "text", "text": "BMR" },
              { "type": "text", "text": savedEmployeeDto.employeeCode },
              { "type": "text", "text": `${savedEmployeeDto.employeeName} ${savedEmployeeDto.employeeLastName}` },
              { "type": "text", "text": deptName },
              { "type": "text", "text": designationName },
              { "type": "text", "text": savedEmployeeDto.reportingManager }
            ]
            const contacts = whatsApp.contacts
            let statusFlag = true
            for (const contact of contacts) {
              const req = await new MessageParameters(contact, 'emp_onboard', parameters, "en")
              const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
              console.log(messageStatus)
              if (!messageStatus.status) {
                statusFlag = false
              } else {
                statusFlag = true
                const companyId = 7;
                const hrmsModuleId = 2;
                const whatsapplogDto = new WhatsAppLogDto(contact, 'l', 'Schemax', companyId, hrmsModuleId)
                // await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
              }
            }
            return new HrmsResponseModel(true, 1, isUpdate == true ? 'Employee Details updated successfully' : 'Employee Details saved successfully');
          } else {
            await transManager.releaseTransaction();
            return new HrmsResponseModel(false, 11110, 'Something went wrong while converting to DTO')
          }
        } else {
          await transManager.releaseTransaction();
          return new HrmsResponseModel(false, 11110, 'Something went wrong while creating attendance logs')
        }
      } else {
        await transManager.releaseTransaction();
        return new HrmsResponseModel(false, 11110, 'Something went wrong while saving employee')
      }
    } catch (error) {
      await transManager.releaseTransaction();
      return error;
    }
  }


  async sendAttendanceStatus(): Promise<GlobalResponseObject> {
    try {
      const manager = getManager();
      let total = 0;
      // let urlMsg = '*click the below link for detail view*';
      const currDate = new Date();
      const yesterday = new Date(currDate); // Create a new Date object for yesterday
      yesterday.setDate(currDate.getDate() - 1);
      const formattedDate = `${yesterday.getFullYear()}-${(yesterday.getMonth() + 1).toString().padStart(2, '0')}-${yesterday.getDate().toString().padStart(2, '0')}`
      const date = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + currDate.getDate();
      const time = currDate.getHours() + ':' + currDate.getMinutes() + ':' + currDate.getSeconds();
      // get all the tokens consumed

      const parameters = [
        { "type": "text", "text": date + " " + time },
        { "type": "text", "text": "BMR" },
        { "type": "text", "text": "HX001" },
        { "type": "text", "text": "HARI" },
        { "type": "text", "text": "Packing" },
        { "type": "text", "text": "Supervisor" },
        { "type": "text", "text": "Raju Garu" }
      ]
      const contacts = whatsApp.contacts
      let statusFlag = true
      for (const contact of contacts) {
        const req = await new MessageParameters(contact, 'emp_onboard', parameters, "en")
        const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
        console.log(messageStatus)
        if (!messageStatus.status) {
          statusFlag = false
        } else {
          statusFlag = true
          const companyId = 7;
          const hrmsModuleId = 2;
          const whatsapplogDto = new WhatsAppLogDto(contact, 'l', 'Schemax', companyId, hrmsModuleId)
          // await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
        }
      }
      if (statusFlag) {
        return new CommonResponse(true, 11108, "Message Sent Sucessfully")
      }
    } catch (error) {
      console.log(error, 'error--')
      throw error;
    }
  }

  // async getAllEmployee(): Promise<HrmsAllResponseModel> {
  //   try {
  //     const employeeDetailsDTO: EmployeeDetailsDTO[] = [];
  //     const EmployeeEntity: EmployeeDetails[] = await this.employeeDetailsRepository.find({ order: { createdAt: 'DESC' } });
  //     const deptIds: number[] = Array.from(new Set(EmployeeEntity.map(res => Number(res.departmentId))));
  //     const AllDepartmentsResponseModel = await this.deptService.getDepartmentNameByDeptIds(deptIds);
  //     if (EmployeeEntity) {
  //       const deptMap = new Map();
  //       AllDepartmentsResponseModel?.data?.forEach(res => {
  //         deptMap.set(res.deptId, res.deptName);
  //       });
  //       EmployeeEntity.forEach(EmployeeEntity => {
  //         const convertedEmployeeDto: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(EmployeeEntity);
  //         convertedEmployeeDto.departmentId = deptMap.get(Number(EmployeeEntity.departmentId)) ? deptMap.get(Number(EmployeeEntity.departmentId)) : EmployeeEntity.departmentId;
  //         employeeDetailsDTO.push(convertedEmployeeDto);
  //       });
  //       const response = new HrmsAllResponseModel(true, 1, 'Employees retrieved successfully', employeeDetailsDTO);
  //       return response;
  //     } else {
  //       return new HrmsAllResponseModel(false,99998, 'Data not found');
  //     }
  //   } catch (err) {
  //     throw err;
  //   }
  // }

  async getAllEmployee(): Promise<CommonResponse> {
    const manager = getManager();
    const query = ` SELECT ed.employee_id AS employeeId, unit_id AS unitId , employee_role AS employeeRole, employee_code AS employeeCode, 
    employee_name AS employeeName, emp_last_name AS employeeLastName, CONCAT(employee_name, ' ', emp_last_name) AS fullName, mobile_no AS mobileNumber, prefix AS prefix, gender AS gender, 
    maritual_status AS maritualStatus, alt_mobile_no AS altMobileNo, priority_one AS priorityOne, 
    priority_type AS priorityType, blood_group AS bloodGroup,  date_of_birth AS dateOfBirth, nationality AS nationality, 
    current_address AS currentAddress, years_of_exp AS yearsOfExperience, company_email AS companyEmail, qualification AS qualification, 
    employee_mode AS employeeMode, employee_type AS employeeType ,email_id AS emailID, permanent_address AS permanentAddress,
    employee_status AS employeeStatus, ed.contractor_name AS contractorNames, shift_group AS shiftGroup, date_of_join AS dateOfJoin, 
    date_of_leave AS dateOfLeave, date_of_entry AS dateOfEntry, workstation_number AS workstationNumber, 
    health_card_number AS healthCardNumber, uan_number AS uanNumber, salary AS salary, bank_account_number AS bankAccountNumber, 
    bank_name AS bankName, ifsc_code AS ifscCode, ed.designation AS designations, emergency_contact_number AS emergencyContactNumber, 
    emergency_contact_name AS emergencyContactName, is_probationary_completed AS isProbationaryCompleted,transportation AS transportation, 
    accommodation AS accommodation, is_audit_completed AS isAuditCompleted, skill_set AS skillSet,pickup_point AS pickupPoint, 
    route_number AS routeNumber,esi_number AS esiNumber, reporting_manager AS reportingManager, emp_category AS employeeCategory, 
    wage_type AS wageType, aadhaar_number AS aadhaarNumber, state AS state, pin_code AS pinCode, permanent_state AS permanentState, 
    permanent_pin_code AS permanentPinCode, ed.is_active AS isActive, ed.created_at AS createdAt, ed.created_user AS createdUser, 
    ed.updated_at AS updatedAt, ed.updated_user AS updatedUser, ed.version_flag AS versionFlag, efd.employee_family_id, efd.family_mem_name,
   efd.relation, efd.fam_date_of_birth, efd.fam_aadhaar_no, efd.contact_no, eed.employee_education_id, eed.emp_qualification, 
   eed.specialization, eed.percentage, eed.date_of_passout, exd.designation AS expDesignation, exd.employee_experience_id , exd.organisation, 
   exd.from_date , exd.to_date,exd.experience, eid.employee_idproof_id, eid.id_type, eid.id_number, d.dept_name AS departmentsId,  ed.pan_number as panNumber, des.designation as designationName, des.designation_id as designation, d.dept_id as departmentId, con.contractor_id as contractorName,
   ed.department_id AS departmentIds,ed.gpa_no AS gpaNo,ed.ghi_no AS ghiNo,ed.is_available as isAvailable FROM ` + appSettings.masters_db + `.employee_details ed
   LEFT JOIN ` + appSettings.masters_db + `.employee_family_details efd ON efd.employee_id = ed.employee_id 
   LEFT JOIN ` + appSettings.masters_db + `.employee_education_details eed ON eed.employee_id = ed.employee_id 
   LEFT JOIN ` + appSettings.masters_db + `.employee_experience_details exd ON exd.employee_id = ed.employee_id 
   LEFT JOIN ` + appSettings.masters_db + `.employee_idproof_details eid ON eid.employee_id = ed.employee_id 
   LEFT JOIN ` + appSettings.masters_db + `.departments d ON d.dept_id = ed.department_id 
   LEFT JOIN ` + appSettings.hrms_db + `.designation des ON des.designation_id = ed.designation
   LEFT JOIN ` + appSettings.hrms_db + `.contractor con ON con.contractor_id = ed.contractor_name


   
   WHERE ed.employee_id > 0 GROUP BY ed.employee_id `
    const data = await manager.query(query)
    if (data.length > 0) {
      return new CommonResponse(true, 2255, 'Data Retreived sucessfilly', data)
    } else {
      return new CommonResponse(false, 1010, 'No data Found')
    }
  }

  async getEmployeeForPayroll(req: PayrollRequestEmp): Promise<CommonResponse> {
    console.log(req, '......................')
    const manager = getManager();
    let query = ` SELECT ed.employee_id AS employeeId, unit_id AS unitId , employee_role AS employeeRole, employee_code AS employeeCode, 
    employee_name AS employeeName, emp_last_name AS employeeLastName, CONCAT(employee_name, ' ', emp_last_name) AS fullName, mobile_no AS mobileNumber, prefix AS prefix, gender AS gender, 
    maritual_status AS maritualStatus, alt_mobile_no AS altMobileNo, priority_one AS priorityOne, 
    priority_type AS priorityType, blood_group AS bloodGroup,  date_of_birth AS dateOfBirth, nationality AS nationality, 
    current_address AS currentAddress, years_of_exp AS yearsOfExperience, company_email AS companyEmail, qualification AS qualification, 
    employee_mode AS employeeMode, employee_type AS employeeType ,email_id AS emailID, permanent_address AS permanentAddress,
    employee_status AS employeeStatus, ed.contractor_name AS contractorNames, shift_group AS shiftGroup, date_of_join AS dateOfJoin, 
    date_of_leave AS dateOfLeave, date_of_entry AS dateOfEntry, workstation_number AS workstationNumber, 
    health_card_number AS healthCardNumber, uan_number AS uanNumber, salary AS salary, bank_account_number AS bankAccountNumber, 
    bank_name AS bankName, ifsc_code AS ifscCode, ed.designation AS designations, emergency_contact_number AS emergencyContactNumber, 
    emergency_contact_name AS emergencyContactName, is_probationary_completed AS isProbationaryCompleted,transportation AS transportation, 
    accommodation AS accommodation, is_audit_completed AS isAuditCompleted, skill_set AS skillSet,pickup_point AS pickupPoint, 
    route_number AS routeNumber,esi_number AS esiNumber, reporting_manager AS reportingManager, emp_category AS employeeCategory, 
    wage_type AS wageType, aadhaar_number AS aadhaarNumber, state AS state, pin_code AS pinCode, permanent_state AS permanentState, 
    permanent_pin_code AS permanentPinCode, ed.is_active AS isActive, ed.created_at AS createdAt, ed.created_user AS createdUser, 
    ed.updated_at AS updatedAt, ed.updated_user AS updatedUser, ed.version_flag AS versionFlag, efd.employee_family_id, efd.family_mem_name,
   efd.relation, efd.fam_date_of_birth, efd.fam_aadhaar_no, efd.contact_no, eed.employee_education_id, eed.emp_qualification, 
   eed.specialization, eed.percentage, eed.date_of_passout, exd.designation AS expDesignation, exd.employee_experience_id , exd.organisation, 
   exd.from_date , exd.to_date,exd.experience, eid.employee_idproof_id, eid.id_type, eid.id_number, d.dept_name AS departmentsId,  ed.pan_number as panNumber, des.designation as designationName, des.designation_id as designation, d.dept_id as departmentId, con.contractor_id as contractorName,
   ed.department_id AS departmentIds FROM ` + appSettings.masters_db + `.employee_details ed
   LEFT JOIN ` + appSettings.masters_db + `.employee_family_details efd ON efd.employee_id = ed.employee_id 
   LEFT JOIN ` + appSettings.masters_db + `.employee_education_details eed ON eed.employee_id = ed.employee_id 
   LEFT JOIN ` + appSettings.masters_db + `.employee_experience_details exd ON exd.employee_id = ed.employee_id 
   LEFT JOIN ` + appSettings.masters_db + `.employee_idproof_details eid ON eid.employee_id = ed.employee_id 
   LEFT JOIN ` + appSettings.masters_db + `.departments d ON d.dept_id = ed.department_id 
   LEFT JOIN ` + appSettings.hrms_db + `.designation des ON des.designation_id = ed.designation
   LEFT JOIN ` + appSettings.hrms_db + `.contractor con ON con.contractor_id = ed.contractor_name
  WHERE ed.employee_id > 0`
    if (req.empType) {
      query += ` AND employee_type = '${req.empType}'`;
    }

    if (req.category) {
      query += ` AND emp_category = '${req.category}'`;
    }
    if (req.departmentId) {
      query += ` AND ed.department_id = '${req.departmentId}'`;
    }
    query += ` GROUP BY ed.employee_id`;
    const data = await manager.query(query)
    if (data.length > 0) {
      return new CommonResponse(true, 2255, 'Data Retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1010, 'No data Found')
    }
  }

  async getAllActiveEmployees(): Promise<HrmsAllResponseModel> {
    try {
      const employeeDetailsDTO: EmployeeDetailsDTO[] = [];
      //retrieves all companies
      const EmployeesEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        order: { employeeName: 'ASC' }, where: { isActive: true },
      });
      if (EmployeesEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        EmployeesEntities.forEach(EmployeeEntity => {
          const convertedEmployeeDto: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(
            EmployeeEntity
          );
          employeeDetailsDTO.push(convertedEmployeeDto);
        });
        const response = new HrmsAllResponseModel(true, 11108, "Employees retrieved successfully", employeeDetailsDTO);
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found'); employeeDetailsDTO
      }
    } catch (err) {
      throw err;
    }
  }

  async getActiveEmployeesById(employeeReq: EmployeeRequest): Promise<HrmsResponseModel> {
    try {
      //retrieves all companies
      const employeeEntities: EmployeeDetails = await this.employeeDetailsRepository.findOne({
        where: { employeeId: employeeReq.employeeId }
      });

      const employeeData: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(employeeEntities);
      if (employeeData) {
        const response = new HrmsResponseModel(true, 11101, 'employee retrived Successfully', employeeData);
        return response;
      }
      else {
        throw new ErrorResponse(11106, 'Something went wrong');
      }
      // generating resposnse
    } catch (err) {
      throw err;
    }
  }

  async getActiveEmpDeptWiseCount(deptReq: DeptRequest): Promise<EmployeesDeptWiseResponseModel> {
    try {
      const deptId = deptReq.deptId;
      const employeeDtos: EmployeesDeptWiseCountDto[] = [];

      const empCount = await getConnection()
        .createQueryBuilder()
        .select("department_id as departmentId, count(*) as count")
        .from(EmployeeDetails, 'employee_details')
        .where(`department_id = ${deptId}`)
        .getRawOne();

      if (empCount) {
        return new EmployeesDeptWiseResponseModel(true, 11111, "", empCount);
      } else {
        throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
      }
    } catch (err) {
      throw err;
    }
  }

  async getActiveEmployeesByEmpCode(empCode: EmployeeCodeRequest): Promise<EmployeeResponseModel> {
    try {
      const employeeEntities: EmployeeDetails = await this.employeeDetailsRepository.findOne({
        where: { employeeCode: empCode.employeeCode, isActive: true }
      });

      const employeeData: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(employeeEntities);
      if (employeeData) {
        const response = new EmployeeResponseModel(true, 11101, 'employee retrived Successfully', employeeData);
        return response;
      }
      else {
        throw new ErrorResponse(11106, 'Something went wrong');
      }
      // generating resposnse
    } catch (err) {
      throw err;
    }
  }

  async getEmployeeByEmpCode(empCode: EmployeeCodeRequest): Promise<EmployeeResponseModel> {
    try {
      const employeeEntities: EmployeeDetails = await this.employeeDetailsRepository.findOne({
        where: { employeeCode: empCode.employeeCode }
      });

      const employeeData: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(employeeEntities);
      if (employeeData) {
        const response = new EmployeeResponseModel(true, 11101, 'employee retrived Successfully', employeeData);
        return response;
      }
      else {
        throw new ErrorResponse(11106, 'Something went wrong');
      }
      // generating resposnse
    } catch (err) {
      throw err;
    }
  }



  async getActiveEmployeesByRole(employeeRoleRequest: EmployeeRoleRequest): Promise<HrmsAllResponseModel> {
    try {
      //retrieves all companies
      const employeeEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        where: { employeeRole: employeeRoleRequest.employeeRole, isActive: true }
      });
      if (employeeEntities.length === 0) {
        throw new ErrorResponse(10000, 'No Records found');
      }
      const employeeData: EmployeeDetailsDTO[] = [];
      employeeEntities.map(employeData => {
        employeeData.push(this.employeeDetailsAdapter.convertEntityToDto(employeData));
      })
      return new HrmsAllResponseModel(true, 11101, 'employee retrived Successfully', employeeData);
    } catch (err) {
      throw err;
    }
  }

  async getActiveEmployeesByDept(employeeDeptRequest: EmployeeDeptRequest): Promise<HrmsAllResponseModel> {
    try {
      const getDeptDetails = await this.deptRepository.findOne({ where: { deptName: employeeDeptRequest.employeeDept } });
      const employeeEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        where: { departmentId: getDeptDetails.deptId, isActive: true }
      });
      if (employeeEntities.length === 0) {
        throw new ErrorResponse(10000, 'No Records found');
      }
      const employeeData: EmployeeDetailsDTO[] = [];
      employeeEntities.map(employeData => {
        employeeData.push(this.employeeDetailsAdapter.convertEntityToDto(employeData));
      })
      return new HrmsAllResponseModel(true, 11101, 'employee retrived Successfully', employeeData);
    }
    catch (err) {
      throw err;
    }
  }

  async getActiveEmployeesByDeptId(deptId: number): Promise<HrmsAllResponseModel> {
    try {
      const getDeptDetails = await this.deptRepository.findOne({ where: { deptId: deptId } });
      const employeeEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        where: { departmentId: getDeptDetails.deptId, isActive: true }
      });
      if (employeeEntities.length === 0) {
        throw new ErrorResponse(10000, 'No Records found');
      }
      const employeeData: EmployeeDetailsDTO[] = [];
      employeeEntities.map(employeData => {
        employeeData.push(this.employeeDetailsAdapter.convertEntityToDto(employeData));
      })
      return new HrmsAllResponseModel(true, 11101, 'employee retrived Successfully', employeeData);
    }
    catch (err) {
      throw err;
    }
  }

  async getAllActiveEmployeesForLeaves(): Promise<HrmsAllResponseModel> {
    // const page: number = 1;
    try {
      const employeeDetailsDTO: EmployeeDetailsDTO[] = [];
      //retrieves all companies
      const EmployeesEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        order: { employeeCode: 'ASC' }, where: { isActive: true },
      });
      if (EmployeesEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        EmployeesEntities.forEach(EmployeeEntity => {
          const convertedEmployeeDto: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(
            EmployeeEntity
          );
          employeeDetailsDTO.push(convertedEmployeeDto);
        });
        const response = new HrmsAllResponseModel(true, 11108, "Employees retrieved successfully", employeeDetailsDTO);
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found'); employeeDetailsDTO
      }
    } catch (err) {
      throw err;
    }
  }

  async updateDesignationForDesignationAction(request: EmployeeDesignationRequest): Promise<CommonResponse> {
    try {
      const data = await this.employeeDetailsRepository.findOne({ where: { employeeId: request.employeeId } })
      const update = await this.employeeDetailsRepository.update({ employeeId: request.employeeId }, { designation: request.designation })
      if (update.affected) {
        return new CommonResponse(true, 11111, 'Designation updated in employees details')
      } else {
        return new CommonResponse(false, 1110, 'Error while updating designation in employee details ')
      }
    } catch (err) {
      return err
    }
  }
  async updateDepartmentForDesignationAction(request: EmployeeDepartmentRequest): Promise<CommonResponse> {
    try {
      const data = await this.employeeDetailsRepository.findOne({ where: { employeeId: request.employeeId } })
      const update = await this.employeeDetailsRepository.update({ employeeId: request.employeeId }, { departmentId: request.departmentId })
      if (update.affected) {
        return new CommonResponse(true, 11111, 'Department updated in employees details')
      } else {

        return new CommonResponse(false, 1110, 'Error while updating department in employee details ')
      }
    } catch (err) {
      return err
    }

  }

  async getActiveEmployeeByEmpCode(empCode: string): Promise<EmployeeResponseModel> {
    try {
      const employeeEntities: EmployeeDetails = await this.employeeDetailsRepository.findOne({
        where: { employeeCode: empCode, isActive: true }
      });
      const employeeData: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(employeeEntities);
      if (employeeData) {
        const response = new EmployeeResponseModel(true, 11101, 'employee retrived Successfully', employeeData);
        return response;
      }
      else {
        throw new ErrorResponse(11106, 'Something went wrong');
      }
    } catch (err) {
      throw err;
    }
  }
  async getEmployeesByUnitId(req?: EmployeeByUnitRequest): Promise<AllEmployeesResponseModel> {

    try {
      let query = this.employeeDetailsRepository
        .createQueryBuilder('employeeDetails')
        .orderBy("employeeDetails.employeeName", "ASC")
        if(req.unitId){
          query=query.where(`employeeDetails.unit_id = ` + req.unitId)
        }
        if(req.screen){
          query = query.andWhere(`employeeDetails.employee_type = 'Salaried Form'`)
        }

        const result = await query.getMany()
      if (result) {
        return new AllEmployeesResponseModel(true, 1111, "Data retreived sucessfully", result)
      } else {
        return new AllEmployeesResponseModel(false, 1111, "Error occured")
      }
    }
    catch (err) {
      return err;
    }
  }

  async getEmployeeUnitData(): Promise<CommonResponse> {
    const manager = getManager()
    let query = ` SELECT employee_type, IF(unit_id = 1, COUNT(1), 0) AS kakinada,
      IF(unit_id = 2, COUNT(1), 0) AS Unit1,
        IF(unit_id = 3, COUNT(1), 0) AS Unit2  FROM  ${appSettings.masters_db}.employee_details GROUP BY employee_type`;
    // query = query + ` GROUP BY si.po_number  ORDER BY poNumber`;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1111, 'Data retreived sucessfully', data)
    } else {
      return new CommonResponse(false, 1111, 'No data')
    }
  }

  async getAllInactiveEmployees(): Promise<HrmsAllResponseModel> {
    try {
      const employeeDetailsDTO: EmployeeDetailsDTO[] = [];
      //retrieves all companies
      const EmployeesEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        order: { employeeCode: 'ASC' }, where: { isActive: false },
      });
      if (EmployeesEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        EmployeesEntities.forEach(EmployeeEntity => {
          const convertedEmployeeDto: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(
            EmployeeEntity
          );
          employeeDetailsDTO.push(convertedEmployeeDto);
        });
        const response = new HrmsAllResponseModel(true, 11108, "Employees retrieved successfully", employeeDetailsDTO);
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found'); employeeDetailsDTO
      }
    } catch (err) {
      throw err;
    }
  }
  async getActiveEmployeesByName(employeeReq: EmployeeNameRequest): Promise<HrmsResponseModel> {
    try {
      //retrieves all companies
      const employeeEntities: EmployeeDetails = await this.employeeDetailsRepository.findOne({
        where: { employeeName: employeeReq.employeeName }
      });

      const employeeData: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(employeeEntities);
      if (employeeData) {
        const response = new HrmsResponseModel(true, 11101, 'employee retrived Successfully', employeeData);
        return response;
      }
      else {
        throw new ErrorResponse(11106, 'Something went wrong');
      }
      // generating resposnse
    } catch (err) {
      throw err;
    }
  }

  async getEmployeeByContractor(req: ContractorIdReq): Promise<CommonResponse> {
    try {

      const empInfo = await this.employeeDetailsRepository.find({ where: { contractorName: req.contractorId } })
      if (empInfo.length > 0) {
        return new CommonResponse(true, 1, 'Data retrieved successfully', empInfo)
      } else {
        return new CommonResponse(false, 0, 'No data found')
      }
    } catch (err) {
      throw err
    }
  }

  async getEmployeeInfoByEmployeeId(req: EmployeeRequest): Promise<CommonResponse> {
    const manager = getManager()
    try {
      const empQry = `SELECT employee_id as employeeId,employee_code AS employeeCode,employee_name AS employeeName,e.contractor_name AS contractorId,c.contractor_name AS contractorName,current_address AS village
      FROM ${appSettings.masters_db} .employee_details e
      LEFT JOIN ${appSettings.hrms_db} .contractor c ON c.contractor_id = e.contractor_name
      WHERE e.employee_id = ${req.employeeId}`
      const empInfo = await manager.query(empQry)
      if (empInfo.length > 0) {
        return new CommonResponse(true, 1, 'Data retrieved', empInfo)
      } else {
        return new CommonResponse(false, 0, 'No data found')
      }
    } catch (err) {
      throw err
    }
  }

  async getAllContractorAgainstEmployees(): Promise<CommonResponse> {
    try {
      const empInfo = await this.employeeDetailsRepository.find({ where: { contractorName: Not(IsNull()) } })
      if (empInfo.length > 0) {
        return new CommonResponse(true, 1, 'Data retrieved', empInfo)
      } else {
        return new CommonResponse(false, 0, 'No data found')
      }
    } catch (err) {
      throw err
    }
  }

  async getDepartmentByTypeOrCategory(req: PayrollRequestEmp): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = `
      SELECT ed.employee_type, ed.department_id as departId, d.dept_name as departName, ed.emp_category
      FROM employee_details ed
      LEFT JOIN departments d ON dept_id = ed.department_id
      WHERE 1=1`
      if (req.empType) {
        query += ` AND employee_type = '${req.empType}'`;
      }

      if (req.category) {
        query += ` AND emp_category = '${req.category}'`;
      }
      query += ` GROUP BY ed.department_id ORDER BY d.dept_name ASC`
      const data = await manager.query(query)

      if (data.length > 0) {
        return new CommonResponse(true, 1, 'Data retrieved', data)
      } else {
        return new CommonResponse(false, 0, 'No data found')
      }
    } catch (err) {
      throw err
    }
  }
  async updateAvalibility(req:EmployeeUpdateReq):Promise<CommonResponse>{
    const transactionManager = new GenericTransactionManager();
    try{
      await transactionManager.startTransaction()
      const update = await transactionManager.getRepository(EmployeeDetails).update({employeeId:req.id},{isAvailable:req.isAvailable})
      if(update){
        const name = req.isAvailable?'Available':'Assigned'
        await transactionManager.completeTransaction()
        return new CommonResponse(true,1, `${name} updated Sucessfully`)
      }else{
        await transactionManager.releaseTransaction()
        return new CommonResponse(false,0,'something went wrong')
      }
    }catch(err){
      throw err
    }
  }
  async getAllActiveDrivers(): Promise<HrmsAllResponseModel> {
    try {
      const employeeDetailsDTO: EmployeeDetailsDTO[] = [];
      //retrieves all companies
      const EmployeesEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        order: { employeeName: 'ASC' }, where: { isActive: true,isAvailable:true,designation:GlobalVariableValues.driverId },
      });
      if (EmployeesEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        EmployeesEntities.forEach(EmployeeEntity => {
          const convertedEmployeeDto: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(
            EmployeeEntity
          );
          employeeDetailsDTO.push(convertedEmployeeDto);
        });
        const response = new HrmsAllResponseModel(true, 11108, "Employees retrieved successfully", employeeDetailsDTO);
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found'); employeeDetailsDTO
      }
    } catch (err) {
      throw err;
    }
  }
  async getAllActiveAuthorisedEmployees(): Promise<HrmsAllResponseModel> {
    try {
      const employeeDetailsDTO: EmployeeDetailsDTO[] = [];
      //retrieves all companies
      const EmployeesEntities: EmployeeDetails[] = await this.employeeDetailsRepository.find({
        order: { employeeName: 'ASC' }, where: { isActive: true,isAuthorised:true },
      });
      if (EmployeesEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        EmployeesEntities.forEach(EmployeeEntity => {
          const convertedEmployeeDto: EmployeeDetailsDTO = this.employeeDetailsAdapter.convertEntityToDto(
            EmployeeEntity
          );
          employeeDetailsDTO.push(convertedEmployeeDto);
        });
        const response = new HrmsAllResponseModel(true, 11108, "Employees retrieved successfully", employeeDetailsDTO);
        return response;
      } else {
        throw new ErrorResponse(99998, 'Data not found'); employeeDetailsDTO
      }
    } catch (err) {
      throw err;
    }
  }
}


